import { j as l } from "../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { Colors as o } from "../../../1-foundations/Colors/Colors.js";
import "@ionic/react";
import "../../../../FeatureFlagProvider-DyczYY1y.js";
import "react";
import "../../../../react-paginate-Lh5zQzpz.js";
import "../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function f(t) {
  const {
    variant: i = "contained",
    isFluid: d,
    disabled: n,
    hasShadow: e,
    onClick: s,
    children: a
  } = t, r = i === "outlined";
  return /* @__PURE__ */ l("button", {
    css: {
      fontWeight: 600,
      cursor: "pointer",
      background: r ? "transparent" : o.blue500,
      padding: 8,
      color: r ? o.blue500 : o.white200,
      borderRadius: 30,
      "&:disabled": {
        background: o.slate200,
        color: o.slate400,
        border: `2px solid ${o.slate200}`
      },
      // optional styles
      ...d && {
        width: "100%"
      },
      ...e && {
        boxShadow: "0px 2px 4px 0px rgba(40, 60, 93, 0.16)"
      },
      ...r && {
        border: `2px solid ${o.blue500}`
      }
    },
    disabled: n,
    onClick: s,
    children: a
  });
}
export {
  f as LogInButton
};
